// extracted by mini-css-extract-plugin
export default {"buy":"buy_buy__4JRGK","title":"buy_title__oXcT7","icon":"buy_icon__-dbxI","contenido":"buy_contenido__1U7eQ"};